/*
 * Filename: d:\projects\AutoFiFront\src\Theme\CarInfoIcon.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Tuesday, February 14th 2023, 11:57:19 am
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */
import { getThemeColor } from "Utils/ThemeColor";
import styled from "styled-components";

const CarInfoIcon = styled.div.attrs((props: any) => ({
    bgColor: props.bgColor,
}))`
margin-right: 0.3rem;
padding-left: -1rem;
min-width: 1rem;
color: ${(props: any) => getThemeColor(props.bgColor)};
`;

export default CarInfoIcon;
